import { render, staticRenderFns } from "./redpackage-record-use.vue?vue&type=template&id=43c67b36&scoped=true&"
import script from "./redpackage-record-use.vue?vue&type=script&lang=js&"
export * from "./redpackage-record-use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c67b36",
  null
  
)

export default component.exports